import {defineCustomElement} from 'extensions/utils';
import stylesheet from './x-checkbox.component.scss?as=stylesheet';
import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {createRef, ref} from 'lit/directives/ref.js';

export class Checkbox extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	checkbox = createRef()

	static get properties () {
		return {
			count: {
				type: Number
			},
			hideCheckbox: {
				attribute: 'hide-checkbox',
				type: Boolean
			},
			label: {
				type: String
			},
			selected: {
				type: Boolean
			}
		};
	}

	constructor () {
		super();

		this.count = 0;
		this.hideCheckbox = false;
		this.label = '';
		this.selected = false;
	}

	updated () {
		if (this.checkbox?.value && this.checkbox?.value?.checked !== this.selected) {
			this.checkbox.value.checked = this.selected;
		}
	}

	handleChange () {
		this.dispatchEvent(new CustomEvent('change'));
	}

	render () {
		const labelClasses = {
			'hide-checkbox': this.hideCheckbox,
			label: true
		};

		return html`
			<div>
				<input id="l-checkbox" @change="${this.handleChange}" type="checkbox" class="checkbox" ${ref(this.checkbox)} />
				<label class="label-wrapper" for="l-checkbox">
					<span class="${classMap(labelClasses)}">${this.label}</span>
					<span class="count">(${this.count})</span>
				</label>
			</div>
		`;
	}
};

defineCustomElement('x-checkbox', Checkbox);
